import { type MetaFunction } from '@remix-run/node'
import countryway from './countryway.png'

export const meta: MetaFunction = () => [
	{ title: 'Countryway' },
	{
		name: 'description',
		content: 'We offer insurance from Countryway.',
	},
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">Countryway</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				<img src={countryway} alt="Countryway" className="w-64" />
				<h3>Products</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Their products are focused on the insurance needs of farms and rural
					communities, including Farmowner's, Homeowners, Auto, Boiler &amp;
					Machinery, and Umbrella coverage.
				</p>
				<h3>Financial Strength</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					A.M. Best has given the ranking of A- (Excellent) to Countryway
					Insurance.
				</p>
				<h3>Contact Information</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Website:{' '}
					<a
						href="https://www.countryway.com/"
						target="_blank"
						rel="noopener noreferrer"
					>
						https://www.countryway.com/ (opens in a new tab)
					</a>
				</p>
				<h3>Make a Payment</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Billing Address:
					<br />
					224 Harrison Street
					<br />
					Syracuse, NY 13202
				</p>
			</p>
			<section>
				<h3>Home Office Address</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Countryway Insurance Company
					<br />
					12580 W Creek Pkwy
					<br />
					Richmond, VA 23238
				</p>
			</section>
		</main>
	)
}
